export class UsuarioModel {

    repcodigo?: string;
    codigo?: string;
    username?: string;
    password?: string;
    login?: boolean;
    nome?: string;
    email?: string;
    cargo?: string;
    empresa?: string;
    filial?: string;
    nomfil?: string;
    departamento?: string;

    constructor () {
        
        this.repcodigo = '';
        this.codigo = '';
        this.username = '';
        this.password = '';
        this.login = true;
        this.nome = 'Menu';
        this.email = '';
        this.cargo = '';
        this.empresa = '';
        this.filial = '';
        this.nomfil = '';
        this.departamento = '';

    }

}



// WEBPACK FOOTER //
// ./src/models/usuario-model.ts